import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteUserPropertiesMutationVariables = Types.Exact<{
  where: Types.User_Properties_Bool_Exp;
}>;


export type DeleteUserPropertiesMutation = { __typename?: 'mutation_root', delete_user_properties?: { __typename?: 'user_properties_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user_properties', id: any, user_id: string, property_id: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, organizationImageURL?: string | null } | null } | null }> } | null };


export const DeleteUserPropertiesDocument = gql`
    mutation deleteUserProperties($where: user_properties_bool_exp!) {
  delete_user_properties(where: $where) {
    affected_rows
    returning {
      id
      user_id
      property_id
      property {
        id
        name
        address
        address_id
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
          country
        }
        organization {
          id
          name
          organizationImageURL
        }
      }
    }
  }
}
    `;
export type DeleteUserPropertiesMutationFn = Apollo.MutationFunction<DeleteUserPropertiesMutation, DeleteUserPropertiesMutationVariables>;

/**
 * __useDeleteUserPropertiesMutation__
 *
 * To run a mutation, you first call `useDeleteUserPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPropertiesMutation, { data, loading, error }] = useDeleteUserPropertiesMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteUserPropertiesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserPropertiesMutation, DeleteUserPropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserPropertiesMutation, DeleteUserPropertiesMutationVariables>(DeleteUserPropertiesDocument, options);
      }
export type DeleteUserPropertiesMutationHookResult = ReturnType<typeof useDeleteUserPropertiesMutation>;
export type DeleteUserPropertiesMutationResult = Apollo.MutationResult<DeleteUserPropertiesMutation>;
export type DeleteUserPropertiesMutationOptions = Apollo.BaseMutationOptions<DeleteUserPropertiesMutation, DeleteUserPropertiesMutationVariables>;